import React from 'react';
import { flatMap } from 'lodash';
import styled from '@emotion/styled';
import { useI18NextContext } from '@components/hooks';
import { Region, Country } from '@model/common';
import { TripTypes } from '@model/common/tours/trip-types';
import { LinkItem } from '@components/sitemap/styles';
import { SitemapResorts } from '@components/sitemap/SitemapResorts';
import { HotelsLink, ResortsLink } from '@components/common/next-link';
import { SectionTitle } from '@components/common/section-title';
import { getDestinationResorts } from '@util/destination';

export interface SitemapHolidaysProps {
  destination: Region | Country;
}

const StyledList = styled.ul({
  margin: 0,
  padding: 0,
  listStylePosition: 'inside'
});

export const SitemapHolidays = ({ destination }: SitemapHolidaysProps) => {
  const t: any = useI18NextContext();
  const { path, display } = destination;

  const resorts = getDestinationResorts(destination);
  const hotels = flatMap(resorts, 'holidays');

  return (
    <div>
      <SectionTitle heading={`${display} ${t(TripTypes.HOLIDAYS)}`} />
      <StyledList>
        <LinkItem>
          <HotelsLink path={path}>
            {t('sitemap__all-hotels--label', { destination: display, count: hotels.length })}
          </HotelsLink>
        </LinkItem>
        <LinkItem>
          <ResortsLink path={path}>{t('sitemap__destination--all-resorts', { destination: display })}</ResortsLink>
        </LinkItem>
      </StyledList>
      <SitemapResorts resorts={resorts} />
    </div>
  );
};
